import Index from "./Pages/Index";
import Gardens from "./Pages/Gardens";
import Crops from "./Pages/Crops";
import Products from "./Pages/Products";
import ProductDetail from "./Pages/ProductDetail";
import Updates from "./Pages/Updates";
import SendUpdates from "./Pages/SendUpdates";
import Logout from "./Pages/Logout";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Planting from "./Pages/Planting";
import Impersonate from "./Admin/Impersonate";
import AdminIndex from "./Admin/Index";
import React from "react";
import {Navigate} from "react-router-dom";
import Team from "./Pages/Team";
import GardenMap from "./Pages/GardenMap";
import Account from "./Pages/Account";
import PlannerV2 from "./Pages/PlannerV2";
import PaymentSuccess from "./Pages/PaymentSuccess";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import Welcome from "./Pages/Welcome";
import AcceptInvite from "./Pages/AcceptInvite";
import Profile from "./Pages/Profile";
import CompanyProfile from "./Pages/CompanyProfile";
import AdminQuestions from "./Admin/AdminQuestions";
import AdminTranslations from "./Admin/AdminTranslations";
import AdminSuppliers from "./Admin/AdminSuppliers";
import AdminAdSpends from "./Admin/AdminAdSpends";
import AdminIcons from "./Admin/AdminIcons";
import AdminHelpVideos from "./Admin/AdminHelpVideos";
import AdminAffiliates from "./Admin/AdminAffiliates";
import ManualOrder from "./Pages/ManualOrder";
import PayForPlan from "./Pages/PayForPlan";
import MultiBed from "./Pages/MultiBed";
import EditCrop from "./Pages/EditCrop";
import Tasks from "./Pages/Tasks";
import CropPlan from "./Pages/CropPlan";
import AccountIos from "./Pages/AccountIos";
import ProfileMap from "./Pages/ProfileMap";
import Offers from "./Pages/Offers";
import Cart from "./Pages/Cart";
import StoreConfiguration from "./Pages/StoreConfiguration";
import CustomerOrderStatus from "./Pages/CustomerOrderStatus";
import UserOrderStatus from "./Pages/UserOrderStatus";
import Orders from "./Pages/Orders";
import Subscribe from "./Pages/Subscribe";
import OfferMap from "./Pages/OfferMap";
import Blog from "./Pages/Blog";
import BlogTag from "./Pages/BlogTag";
import BlogPost from "./Pages/BlogPost";
import TermsOfService from "./Pages/TermsOfService";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import PrintableOrderForm from "./Pages/PrintableOrderForm";
import TestBugsink from "./Pages/TestBugsink";
import AutoPlanner from "./Pages/AutoPlanner";
import AffiliateRegister from "./Pages/AffiliateRegister";

const routes = [
    // Root route now handled by SSR server
    // Remove this route or redirect authenticated users to /gardens
    {
        path: '/',
        element: <Index />
    },
    {
        path: '/gardens',
        element: <Gardens/>
    },
    {
        path: "/planner/:id",
        element: <PlannerV2/>
    },
    {
        path: "/map/:id",
        element: <GardenMap/>
    },
    {
        path: "/crops",
        element: <Crops/>
    },
    {
        path: "/products",
        element: <Products/>
    },
    {
        path: "/products/:id",
        element: <ProductDetail/>
    },
    {
        path: "/crops/:id",
        element: <EditCrop/>
    },
    {
        path: "/updates",
        element: <Updates/>
    },
    {
        path: "/updates/send",
        element: <SendUpdates/>
    },
    {
        path: "/logout",
        element: <Logout />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/register",
        element: <Register />
    },
    {
        path: "/forgot-password",
        element: <ForgotPassword />
    },
    {
        path: "/reset-password/:user_id/:token",
        element: <ResetPassword />
    },
    {
        path: "/garden/:garden_id/bed/:bed_id/planting/:planting_id",
        element: <Planting />
    },
    {
        path: "/garden/:garden_id/bed/:bed_id/multi",
        element: <MultiBed />
    },
    {
        path: "/admin/impersonate/:user_id",
        element: <Impersonate />
    },
    {
        path: "/admin/questions",
        element: <AdminQuestions />
    },
    {
        path: "/admin/translations",
        element: <AdminTranslations />
    },
    {
        path: "/admin/suppliers",
        element: <AdminSuppliers />
    },
    {
        path: "/admin/users",
        element: <AdminIndex />
    },
    {
        path: "/admin/blog",
        element: <AdminIndex />
    },
    {
        path: "/admin/ad-spends",
        element: <AdminAdSpends />
    },
    {
        path: "/admin/icons",
        element: <AdminIcons />
    },
    {
        path: "/admin/help-videos",
        element: <AdminHelpVideos />
    },
    {
        path: "/admin/affiliates",
        element: <AdminAffiliates />
    },
    {
        path: "/admin/",
        element: <AdminIndex />
    },
    {
        path: "/orders/create",
        element: <ManualOrder />
    },
    {
        path: "/team/accept/:id/:token",
        element: <AcceptInvite />
    },
    {
        path: '/tasks',
        element: <Tasks/>
    },
    {
        path: '/cropplan',
        element: <CropPlan/>
    },
    {
        path: '/auto-planner',
        element: <AutoPlanner/>
    },
    {
        path: "/team",
        element: <Team />
    },
    {
        path: "/profile",
        element: <CompanyProfile />
    },
    {
        path: "/account",
        element: <Account />
    },
    {
        path: "/account-ios",
        element: <AccountIos />
    },
    {
        path: "/payment/success",
        element: <PaymentSuccess />
    },
    {
        path: "/welcome",
        element: <Welcome />
    },
    {
        path: "/pay/:planId",
        element: <PayForPlan />
    },
    {
        path: "/profile/map",
        element: <ProfileMap />
    },
    {
        path: "/markt/kaart",
        element: <OfferMap />
    },
    {
        path: "/offers",
        element: <Offers />
    },
    {
        path: "/offers/print",
        element: <PrintableOrderForm />
    },
    {
        path: "/store",
        element: <StoreConfiguration />
    },
    {
        path: "/orders",
        element: <Orders />
    },
    {
        path: "/subscribe",
        element: <Subscribe />
    },
    {
        path: "/:slug/cart",
        element: <Cart />
    },
    {
        path: '/customer/order/status/:order_id/:secret',
        element: <CustomerOrderStatus />
    },
    {
        path: '/order/status/:order_id/:secret',
        element: <UserOrderStatus />
    },
    {
        path: '/unsubscribed',
        element: <h1>Je zult geen email meer ontvangen!</h1>
    },
    {
        path: '/404',
        element: <h1>Sorry, we konden deze pagina niet vinden.</h1>
    },
    {
        path: "/blog/tag/:tag",
        element: <BlogTag/>
    },
    {
        path: "/blog/:slug",
        element: <BlogPost/>
    },
    {
        path: "/blog",
        element: <Blog/>
    },
    {
        path: "/tos",
        element: <TermsOfService/>
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy/>
    },
    {
        path: "/affiliate-aanmelden",
        element: <AffiliateRegister/>
    },
    {
        path: "/affilliate-aanmelden",
        element: <Navigate to="/affiliate-aanmelden" replace />
    },
    {
        path: "/test-bugsink",
        element: <TestBugsink/>
    },
    {
        path: "/:slug",
        element: <Profile/>
    }
];

export default routes;